<mat-form-field fxFlex *transloco="let t; read: 'scInlineDeviceNameInput'">
	<div>
		<prism-auto-tooltip placement="top">
			<input
				matInput
				[placeholder]="t('device-name')"
				[formControl]="nameControl"
				(change)="onDeviceNameChange(nameControl.value)"
				(click)="onClick($event)"
				(dblclick)="onDoubleClick($event)"
				(blur)="onBlur()"
				[errorStateMatcher]="matcher"
				#input
			/>

			@if (nameControl.hasError('required')) {
				<mat-error #error> {{ t('required') }} </mat-error>
			} @else if (nameControl.hasError('maxlength')) {
				<mat-error #error>
					{{ t('device-name-max-length', { number: maxLength + 1 }) }}
				</mat-error>
			} @else if (nameControl.hasError('pattern') && !nameControl.hasError('maxlength')) {
				<mat-error #error>
					{{ t('device-name-invalid-character') }}
				</mat-error>
			}
		</prism-auto-tooltip>
	</div>
</mat-form-field>
